/* global BigInt */
export const expenseExclusionFields = [
  { name: 'documentTemplate', label: '单据模板' },
  { name: 'expenseTypeLevel1', label: '1级费用类型' },
  { name: 'expenseTypeLevel2', label: '2级费用类型' },
  { name: 'expenseTypeLevel3', label: '3级费用类型' },
  { name: 'departmentLevel2', label: '2级部门' },
  { name: 'departmentLevel3', label: '3级部门' },
  { name: 'expenseDepartment', label: '费用承担部门' },
  { name: 'submitterDepartment', label: '提单部门' },
];
export const describeExpenseExclusion = (rule) =>
  expenseExclusionFields
    .filter(({ name }) => rule[name])
    .map(({ name, label }) => `${label}：${rule[name]}`)
    .join('；') || '未设置条件';
export const normalizeExclusionDraft = (values) => {
  const conditions = Object.fromEntries(
    expenseExclusionFields.map(({ name }) => [name, values[name]?.trim() || null]),
  );
  if (!Object.values(conditions).some(Boolean)) throw new Error('请至少设置一个排除条件');
  return { ...conditions, enabled: values.enabled ?? true };
};
export const formatExclusionAmount = (value) => {
  const cents = BigInt(value);
  const absolute = cents < 0n ? -cents : cents;
  return `${cents < 0n ? '-' : ''}${absolute / 100n}.${String(absolute % 100n).padStart(2, '0')}`;
};
